import { INTERNAL_PROP_PREFIX } from 'emma-common-ts';
import { get } from 'lodash';

export function cleanUpTempProps<T>(data: T): T {
  if (!data || 'object' !== typeof data) {
    return data;
  }
  const clean: Partial<T> = {};
  for (const prop of Object.getOwnPropertyNames(data as object)) {
    if (!prop.startsWith(INTERNAL_PROP_PREFIX)) {
      clean[prop as keyof T] = get(data, prop);
    }
  }
  return clean as T;
}
